import Stack from '@admin/components/stack'
import Downgrade from './downgrade'
import PropTypes from 'prop-types'
import Overview from './overview'
import Cancel from './cancel'
import Pause from './pause'
import React from 'react'

class CancelContainer extends React.Component {

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  state = {
    variants: []
  }

  _handlePop = this._handlePop.bind(this)

  stackRef = React.createRef()

  render() {
    return <Stack { ...this._getStack()} />
  }

  componentDidMount() {
    this._handleOverview()
  }

  _getStack() {
    return {
      display_name: 'cancellation',
      ref: this.stackRef
    }
  }

  _handleDone() {
    const { variants } = this.state
    this.props.onNext({ variants })
  }

  _handleOverview() {
    const { props, onBack } = this.props
    this._handlePush(Overview, { 
      plans: props.plans,
      subscription: props.subscription,
      onBack,
      onNext: ({ strategy }) => {
        this.setState({ strategy })
        if(strategy === 'pause') return this._handlePause()
        if(strategy === 'cancel') return this._handleCancel()
        if(strategy === 'downgrade') return this._handleDowngrade()
      }
    })
  }


  _handlePause() {
    const { onSave } = this.props
    this._handlePush(Pause, {
      onBack: this._handlePop,
      onSave
    })
  }

  _handleCancel() {
    const { onSave } = this.props
    this._handlePush(Cancel, {
      onBack: this._handlePop,
      onSave
    })
  }

  _handleDowngrade() {
    const { props, onSave } = this.props
    this._handlePush(Downgrade, {
      props, 
      onBack: this._handlePop,
      onSave
    })
  }

  _handlePop(index = -1) {
    this.stackRef.current.pop(index)
  }

  _handlePush(component, props) {
    this.stackRef.current.push({ component, props })
  }

}

export default CancelContainer

